import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'

import EducationalContent from './educational-content'
import { tr } from '../../../helpers/languages'

const CompletedEducationalContent = (props) => {
    return (
        <Segment className='completed-exercises' id='completed-exercises'>
            <Segment className='assigned-exercises'>
                <Segment className='exercises-title'>{tr('ASSIGNED_EDUCATIONAL_MATERIAL')}</Segment>
                <Grid className='exercises-header'>
                    <Grid.Row>
                        <Grid.Column className='name'>{tr('NAME')}</Grid.Column>
                        <Grid.Column className='status'>{tr('STATUS')}</Grid.Column>
                    </Grid.Row>
                </Grid>
                <EducationalContent
                    educationalContent={props.educationalContent}
                />
            </Segment>
        </Segment>
    )
}

export default CompletedEducationalContent



// WEBPACK FOOTER //
// ./src/components/common/completed-educational-content/index.js